// Check the value that will actually be saved, not a sanitised copy.
export const superAbnFormatError = value =>
    /\s/.test(value || "") ? "Super ABN must not contain spaces." : "";

export const superBsbFormatError = value =>
    /[-\u2010-\u2015\u2212\uFE63\uFF0D]/.test(value || "") ? "BSB must not contain dashes." : "";
